import React, { useState, useCallback } from 'react';
import useResidentDetailsFetch from '@hooks/useResidentDetailsFetch';
import Instruction from './components/Instruction';
import SharingByEmail, { NextOfKinDetails } from './components/SharingByEmail';
import SharingPrintedCopies from './components/SharingPrintedCopies';
import SharedCarePlansTable from './components/SharingByEmailTable';
import AdvanceCarePlanCompletion from './components/AdvanceCarePlanCompletion';
import DownloadPrintShare from './components/DownloadPrintShare';
import SharedPrintedCopiesTable from './components/SharedPrintedCopiesTable';
import SuccessNotificationBanner from '../../SuccessNotificationBanner';

enum StepChangeDirection {
  Previous = 'prev',
  Next = 'next',
}

interface StepSixProps {
  role: string;
  slug: string | undefined;
  userId: string;
  changeStep: (status: StepChangeDirection) => void;
}

function StepSix({ role, slug, userId, changeStep }: StepSixProps) {
  const [emailFormSubmitted, setEmailFormSubmitted] = useState(false);
  const [printedFormSubmitted, setPrintedFormSubmitted] = useState(false);
  const [nextOfKinDetails, setNextOfKinDetails] = useState<NextOfKinDetails>({
    fullName: '',
    relationship: '',
  });
  const [acpCompletionPanel, setAcpCompletionPanel] = useState({
    type: '',
    title: '',
    content: '',
    isShow: false,
  });
  const { residentDetails } = useResidentDetailsFetch(slug) || undefined;

  const handleEmailFormSubmit = useCallback(() => {
    setEmailFormSubmitted(prev => !prev);
  }, []);

  const handlePrintedFormSubmit = useCallback(() => {
    setPrintedFormSubmitted(prev => !prev);
  }, []);

  return (
    <div className="mt-5 md:mt-10">
      <h1 className="govuk-heading-xl">
        {residentDetails?.profile?.full_name} - Sharing
      </h1>
      {acpCompletionPanel.isShow && acpCompletionPanel.type === 'completed' && (
        <SuccessNotificationBanner
          title={acpCompletionPanel.title}
          duration={3000}
        />
      )}
      {acpCompletionPanel.isShow &&
        acpCompletionPanel.type === 'inprogress' && (
          <SuccessNotificationBanner
            title={acpCompletionPanel.title}
            duration={3000}
          />
        )}

      <Instruction />
      <SharingByEmail
        role={role}
        userId={userId}
        onFormSubmit={handleEmailFormSubmit}
        residentDetails={residentDetails}
        nextOfKinDetails={nextOfKinDetails}
        setNextOfKinDetails={setNextOfKinDetails}
      />
      <SharedCarePlansTable
        userId={userId}
        formSubmitted={emailFormSubmitted}
      />
      <SharingPrintedCopies
        role={role}
        userId={userId}
        onFormSubmit={handlePrintedFormSubmit}
        residentDetails={residentDetails}
        nextOfKinDetails={nextOfKinDetails}
      />
      <SharedPrintedCopiesTable
        userId={userId}
        formSubmitted={printedFormSubmitted}
      />
      <AdvanceCarePlanCompletion
        role={role}
        userId={userId}
        residentDetails={residentDetails}
        setAcpCompletionPanel={setAcpCompletionPanel}
      />
      <DownloadPrintShare
        slug={slug}
        userId={userId}
        fullName={residentDetails?.profile?.full_name}
      />
      <button
        type="submit"
        className="govuk-button govuk-button--secondary mt-10 govuk-bp:mt-14"
        onClick={() => changeStep(StepChangeDirection.Previous)}
      >
        Previous
      </button>
    </div>
  );
}

export default StepSix;
